import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'

// save member role
export const saveRole = async ({ params, token }) => {
  try {
    //return await clientPublic
    return await clientPublicService
      .post('/core/project/project-role/mapping', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectRoleEdit = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('projectrole/mapping/edit', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

//add Role
export const addRole = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('projectrole', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getListProjectRole = async ({ project_id, token }) => {
  try {
    return await clientPublic
      .get(`projectrole?project_id=${project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteMemberRole = async ({ params, token }) => {
  try {
    return await clientPublic
      .delete(`projectrole/mapping`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        data: params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// save name role
export const projectRoleSave = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('projectrole', params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
// list memberRole
export const getListMember = async ({ project_id, token }) => {
  try {
    return await clientPublic
      .get(`/projectrole/member?project_id=${project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteRole = async ({ params, token }) => {
  try {
    return await clientPublic
      .delete(`projectrole/${params.row}?project_id=${params.project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        data: params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

//EDIT ROLE NAME
export const EDITROLE_NAME_API_POST = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`projectrole/${params.role_id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
